<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="riskProfil">
                <div class="formControl mt">
                  <title
                    direction="left"
                    [style]="{
                      'font-size': '16px',
                      color: '#3376F6',
                      'margin-bottom': '1.5rem',
                    }"
                  >
                    Situation personnelle
                  </title>
                  <pr-input-radio
                    formControlName="maritalStatus"
                    direction="column"
                    [isDefault]="false"
                    [options]="options1"
                    columns="1"
                    [derrors]="derrors"
                  >
                  </pr-input-radio>
                </div>
                <div class="formControl mt">
                  <title
                    direction="left"
                    [style]="{
                      'font-size': '16px',
                      color: '#3376F6',
                      'margin-bottom': '1.5rem',
                    }"
                  >
                    Statut d'occupation
                  </title>
                  <pr-input-radio
                    formControlName="occupancyStatus"
                    direction="column"
                    [isDefault]="false"
                    [options]="options2"
                    columns="1"
                    [derrors]="derrors"
                  >
                  </pr-input-radio>
                </div>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer [form]="form" (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
